import React from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
} from "../actions";
import UserService from "../services/UserService";
import NotificationDropdown from "./notifications/NotificationDropdown";
import Logo from "../assets/images/logo_marketplace.png";
import LogoWhite from "../assets/images/logo_marketplace.png";
import UserImage from "../assets/images/user.png";

class NavbarMenu extends React.Component {
  state = {
    expandedMenuIds: [],
  };

  componentDidMount() {
    this.props.tostMessageLoad(true);
  }

  appPath = (path) => `${process.env.PUBLIC_URL}/${String(path || "").replace(/^\/+/, "")}`;

  normalizePath = (path) => {
    const value = String(path || "").trim();
    if (!value) {
      return "/";
    }

    const withLeadingSlash = value.startsWith("/") ? value : `/${value}`;
    if (withLeadingSlash.length > 1 && withLeadingSlash.endsWith("/")) {
      return withLeadingSlash.slice(0, -1);
    }

    return withLeadingSlash;
  };

  getRelativePathname = () => {
    const publicUrl = process.env.PUBLIC_URL || "";
    const pathname = window.location.pathname || "/";
    const normalized = publicUrl && pathname.startsWith(publicUrl)
      ? pathname.slice(publicUrl.length)
      : pathname;
    return this.normalizePath(normalized);
  };

  getCurrentUserName = () => {
    const parsedToken = UserService.getParsedToken() || {};
    const fullName = [parsedToken.given_name, parsedToken.family_name]
      .filter(Boolean)
      .join(" ")
      .trim();

    return (
      parsedToken.name ||
      fullName ||
      parsedToken.preferred_username ||
      parsedToken.email ||
      "Utente"
    );
  };

  getFallbackMenu = () => {
    const { sellerMode, isAdmin } = this.props;

    if (sellerMode) {
      const sellerMenu = [
        {
          _id: "menu_seller_requests_root",
          label: "Richieste",
          icon: "icon-layers",
          path: "",
          children: [
            {
              _id: "menu_seller_requests",
              label: "Richieste ricevute",
              icon: "icon-envelope-open",
              path: "/seller-richieste",
              children: [],
            },
            {
              _id: "menu_seller_requests_archive",
              label: "Storico richieste",
              icon: "fa-archive",
              path: "/seller-storico",
              children: [],
            },
          ],
        },
      ];

      if (isAdmin) {
        sellerMenu.push({
          _id: "menu_admin_root",
          label: "Amministrazione",
          icon: "icon-settings",
          path: "",
          children: [
            {
              _id: "menu_admin_seller_approvals",
              label: "Approvazioni venditori",
              icon: "icon-user-following",
              path: "/admin/venditori",
              children: [],
            },
          ],
        });
      }

      return sellerMenu;
    }

    if (isAdmin) {
      return [
        {
          _id: "menu_admin_root",
          label: "Amministrazione",
          icon: "icon-settings",
          path: "",
          children: [
            {
              _id: "menu_admin_seller_approvals",
              label: "Approvazioni venditori",
              icon: "icon-user-following",
              path: "/admin/venditori",
              children: [],
            },
          ],
        },
      ];
    }

    return [
      {
        _id: "menu_dashboard",
        label: "Dashboard",
        icon: "icon-home",
        path: "/dashboard",
        children: [],
      },
      {
        _id: "menu_requests_root",
        label: "Richieste",
        icon: "icon-layers",
        path: "",
        children: [
          {
            _id: "menu_requests_list",
            label: "Le mie richieste",
            icon: "fa-file-lines",
            path: "/richieste",
            children: [],
          },
          {
            _id: "menu_requests_new",
            label: "Nuova richiesta",
            icon: "fa-plus-circle",
            path: "/dashboard",
            children: [],
          },
          {
            _id: "menu_requests_archive",
            label: "Storico richieste",
            icon: "fa-archive",
            path: "/storico-richieste",
            children: [],
          },
        ],
      },
    ];
  };

  normalizeMenu = (items = []) =>
    items.map((item) => ({
      ...item,
      _id: item._id || item.id || item.code || item.label,
      path: item.path || "",
      icon: item.icon || "icon-menu",
      children: this.normalizeMenu(item.children || []),
    }));

  getMenuItems = () => {
    const { dynamicMenu } = this.props;
    const source = Array.isArray(dynamicMenu) && dynamicMenu.length > 0
      ? dynamicMenu
      : this.getFallbackMenu();
    return this.normalizeMenu(source);
  };

  isItemActive = (item) => {
    const currentPath = this.getRelativePathname();
    const rawItemPath = String(item.path || "").trim();
    if (!rawItemPath) {
      return false;
    }

    const itemPath = this.normalizePath(rawItemPath);

    if (!itemPath) {
      return false;
    }

    if (itemPath === "/") {
      return currentPath === "/";
    }

    const customerHistoryPaths = new Set(["/storico-richieste", "/richieste/storico"]);
    const sellerHistoryPaths = new Set([
      "/seller-storico",
      "/seller/storico-richieste",
      "/seller/richieste-ricevute/storico",
    ]);
    const customerActiveRequestsPaths = new Set(["/richieste"]);
    const sellerActiveRequestsPaths = new Set([
      "/seller-richieste",
      "/seller/richieste-ricevute",
    ]);

    if (itemPath === "/richieste") {
      return (
        customerActiveRequestsPaths.has(currentPath) ||
        (currentPath.startsWith("/richieste/") && !customerHistoryPaths.has(currentPath))
      );
    }

    if (itemPath === "/seller-richieste" || itemPath === "/seller/richieste-ricevute") {
      return (
        sellerActiveRequestsPaths.has(currentPath) ||
        ((currentPath.startsWith("/seller-richieste/") ||
          currentPath.startsWith("/seller/richieste-ricevute/")) &&
          !sellerHistoryPaths.has(currentPath)
        )
      );
    }

    if (customerHistoryPaths.has(itemPath)) {
      return customerHistoryPaths.has(currentPath);
    }

    if (sellerHistoryPaths.has(itemPath)) {
      return sellerHistoryPaths.has(currentPath);
    }

    return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
  };

  hasActiveDescendant = (item) =>
    (item.children || []).some(
      (child) => this.isItemActive(child) || this.hasActiveDescendant(child)
    );

  isMenuExpanded = (item) =>
    this.state.expandedMenuIds.includes(item._id) || this.hasActiveDescendant(item);

  toggleMenu = (itemId) => {
    this.setState((previousState) => ({
      expandedMenuIds: previousState.expandedMenuIds.includes(itemId)
        ? previousState.expandedMenuIds.filter((currentId) => currentId !== itemId)
        : [...previousState.expandedMenuIds, itemId],
    }));
  };

  renderMenuItem = (item, isChild = false) => {
    const hasChildren = Array.isArray(item.children) && item.children.length > 0;
    const isActive = this.isItemActive(item);
    const isExpanded = this.isMenuExpanded(item);
    const itemClassName = isActive || this.hasActiveDescendant(item) ? "active" : "";

    if (hasChildren) {
      return (
        <li key={item._id} className={itemClassName}>
          <a
            href="#!"
            className="has-arrow"
            aria-expanded={isExpanded}
            onClick={(event) => {
              event.preventDefault();
              this.toggleMenu(item._id);
            }}
          >
            {!isChild ? <i className={item.icon}></i> : null}
            <span>{item.label}</span>
          </a>
          <ul className={`collapse${isExpanded ? " in" : ""}`}>
            {item.children.map((child) => this.renderMenuItem(child, true))}
          </ul>
        </li>
      );
    }

    return (
      <li key={item._id} className={itemClassName}>
        <Link
          to={this.appPath(item.path)}
          className={isActive ? "is-route-active" : ""}
          onClick={() => document.body.classList.remove("offcanvas-active")}
        >
          {!isChild ? <i className={item.icon}></i> : null}
          <span>{item.label}</span>
        </Link>
      </li>
    );
  };

  render() {
    const {
      themeColor,
      toggleNotification,
      headerOnly,
      topbarOnly,
      sellerMode,
      showVendorLogin,
      notifications,
      unreadNotificationCount,
      onNotificationClick,
      onMarkAllRead,
    } = this.props;
    const appPath = this.appPath;
    const currentUserName = this.getCurrentUserName();
    const menuItems = this.getMenuItems();
    document.body.classList.add(themeColor);

    return (
      <div>
        <nav
          className={`navbar navbar-fixed-top ${
            headerOnly ? "marketplace-navbar" : ""
          } ${sellerMode ? "seller-navbar-theme" : ""}`}
        >
          <div className="container-fluid">
            {!headerOnly && !topbarOnly ? (
              <div className="navbar-btn">
                <button
                  className="btn-toggle-offcanvas"
                  type="button"
                  aria-label="Apri menu di navigazione"
                  onClick={() => {
                    this.props.onPressSideMenuToggle();
                  }}
                >
                  <i className="lnr lnr-menu fa fa-bars"></i>
                </button>
              </div>
            ) : null}

            <div className="navbar-brand">
              <a href={appPath("dashboard")}>
                <img
                  src={
                    document.body.classList.contains("full-dark")
                      ? LogoWhite
                      : Logo
                  }
                  alt="Marketplace"
                  className="img-responsive logo"
                />
              </a>
            </div>

            <div className="navbar-right">
              {headerOnly ? (
                <div className="marketplace-header-actions">
                  {showVendorLogin ? (
                    <div className="marketplace-header-entry-grid">
                      <a
                        href={`${appPath("login")}?role=customer`}
                        className="btn btn-outline-primary marketplace-header-vendor-btn marketplace-header-vendor-btn--secondary"
                      >
                        <i className="fa fa-user-circle m-r-10"></i>
                        Area clienti
                      </a>
                      <span> </span>
                      <a
                        href={`${appPath("login")}?role=vendor`}
                        className="btn btn-outline-primary marketplace-header-vendor-btn"
                      >
                        <i className="fa fa-user-md m-r-10"></i>
                        Area venditori
                      </a>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div id="navbar-menu">
                  <ul className="nav navbar-nav">
                    <NotificationDropdown
                      isOpen={toggleNotification}
                      notifications={notifications}
                      unreadCount={unreadNotificationCount}
                      onToggle={() => {
                        this.props.onPressNotification();
                      }}
                      onClose={() => {
                        if (toggleNotification) {
                          this.props.onPressNotification();
                        }
                      }}
                      onNotificationClick={onNotificationClick}
                      onMarkAllRead={onMarkAllRead}
                    />
                    <li>
                      <a
                        href="#logout"
                        className="icon-menu"
                        onClick={(event) => {
                          event.preventDefault();
                          UserService.doLogout();
                        }}
                      >
                        <i className="icon-login"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </nav>

        <button
          type="button"
          className="mobile-nav-backdrop"
          aria-label="Chiudi menu di navigazione"
          onClick={() => this.props.onPressSideMenuToggle()}
        />

        {!headerOnly && !topbarOnly ? (
          <div
            id="left-sidebar"
            className={`sidebar ${sellerMode ? "seller-left-sidebar" : ""}`}
          >
            <div className="sidebar-scroll">
              <div className="user-account">
                <img
                  src={UserImage}
                  className="rounded-circle user-photo"
                  alt="User Profile"
                />
                <Dropdown>
                  <span>Welcome,</span>
                  <Dropdown.Toggle
                    variant="none"
                    as="a"
                    id="dropdown-basic"
                    className="user-name"
                  >
                    <strong>{currentUserName}</strong>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-right account">
                    <Dropdown.Item
                      href="#logout"
                      onClick={(event) => {
                        event.preventDefault();
                        UserService.doLogout();
                      }}
                    >
                      <i className="icon-power"></i>Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <hr />
              </div>
              <Nav id="left-sidebar-nav" className="sidebar-nav">
                <ul id="main-menu" className="metismenu">
                  {menuItems.map((item) => this.renderMenuItem(item))}
                </ul>
              </Nav>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

NavbarMenu.defaultProps = {
  headerOnly: false,
  topbarOnly: false,
  sellerMode: false,
  isAdmin: false,
  showVendorLogin: false,
  dynamicMenu: [],
  notifications: [],
  unreadNotificationCount: 0,
  onNotificationClick: () => {},
  onMarkAllRead: () => {},
};

NavbarMenu.propTypes = {
  addClassactive: PropTypes.array.isRequired,
  addClassactiveChild: PropTypes.array.isRequired,
  addClassactiveChildApp: PropTypes.array.isRequired,
  addClassactiveChildFM: PropTypes.array.isRequired,
  addClassactiveChildBlog: PropTypes.array.isRequired,
  addClassactiveChildUI: PropTypes.array.isRequired,
  addClassactiveChildWidgets: PropTypes.array.isRequired,
  addClassactiveChildAuth: PropTypes.array.isRequired,
  addClassactiveChildPages: PropTypes.array.isRequired,
  addClassactiveChildForms: PropTypes.array.isRequired,
  addClassactiveChildTables: PropTypes.array.isRequired,
  addClassactiveChildChart: PropTypes.array.isRequired,
  addClassactiveChildMaps: PropTypes.array.isRequired,
  themeColor: PropTypes.string.isRequired,
  generalSetting: PropTypes.array.isRequired,
  toggleNotification: PropTypes.bool.isRequired,
  toggleEqualizer: PropTypes.bool.isRequired,
  topbarOnly: PropTypes.bool,
  sellerMode: PropTypes.bool,
  isAdmin: PropTypes.bool,
  showVendorLogin: PropTypes.bool,
  dynamicMenu: PropTypes.array,
  notifications: PropTypes.array,
  unreadNotificationCount: PropTypes.number,
  onNotificationClick: PropTypes.func,
  onMarkAllRead: PropTypes.func,
};

const mapStateToProps = ({ navigationReducer }) => {
  const {
    addClassactive,
    addClassactiveChild,
    addClassactiveChildApp,
    addClassactiveChildFM,
    addClassactiveChildBlog,
    addClassactiveChildUI,
    addClassactiveChildWidgets,
    addClassactiveChildAuth,
    addClassactiveChildPages,
    addClassactiveChildForms,
    addClassactiveChildTables,
    addClassactiveChildChart,
    addClassactiveChildMaps,
    themeColor,
    generalSetting,
    toggleNotification,
    toggleEqualizer,
    menuProfileDropdown,
    sideMenuTab,
    isToastMessage,
  } = navigationReducer;
  return {
    addClassactive,
    addClassactiveChild,
    addClassactiveChildApp,
    addClassactiveChildFM,
    addClassactiveChildBlog,
    addClassactiveChildUI,
    addClassactiveChildWidgets,
    addClassactiveChildAuth,
    addClassactiveChildPages,
    addClassactiveChildForms,
    addClassactiveChildTables,
    addClassactiveChildChart,
    addClassactiveChildMaps,
    themeColor,
    generalSetting,
    toggleNotification,
    toggleEqualizer,
    menuProfileDropdown,
    sideMenuTab,
    isToastMessage,
  };
};

export default connect(mapStateToProps, {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
})(NavbarMenu);





